/**
 * Environment-specific product ID mappings for Skills Tutor courses.
 * This maps logical course names to environment-specific Salesforce product IDs.
 */

export const productIdMappings = {
  uat: {
    'customer-service-basic': '01tdk000005PEsvAAG',
    'customer-service-intermediate': '01tdk000005PF5pAAG',
    'job-interview-basic': '01tdk000005PFKLAA4',
    'job-interview-intermediate': '01tdk000005PFQnAAO',
    'meeting-basic': '01tdk000005PFaTAAW',
    'meeting-intermediate': '01tdk000005PFgvAAG',
    'negotiation-basic': '01tdk000005PFtpAAG',
    'negotiation-intermediate': '01tdk000005PG0HAAW',
    'presentation-basic': '01tdk000005PG9xAAG',
    'presentation-intermediate': '01tdk000005PGEnAAO',
    'writing-basic': '01tdk000005PGQ5AAO',
    'writing-intermediate': '01tdk000005PFSRAA4',
    'social-basic': '01tdk000005PGebAAG',
    'social-intermediate': '01tdk000005PGhpAAG',
  },
  prod: {
    'customer-service-basic': '01tdk000005PEsvAAG',
    'customer-service-intermediate': '01tdk000005PF5pAAG',
    'job-interview-basic': '01tdk000005PFKLAA4',
    'job-interview-intermediate': '01tdk000005PFQnAAO',
    'meeting-basic': '01tdk000005PFaTAAW',
    'meeting-intermediate': '01tdk000005PFgvAAG',
    'negotiation-basic': '01tdk000005PFtpAAG',
    'negotiation-intermediate': '01tdk000005PG0HAAW',
    'presentation-basic': '01tdk000005PG9xAAG',
    'presentation-intermediate': '01tdk000005PGEnAAO',
    'writing-basic': '01tdk000005PGQ5AAO',
    'writing-intermediate': '01tdk000005PFSRAA4',
    'social-basic': '01tdk000005PGebAAG',
    'social-intermediate': '01tdk000005PGhpAAG',
  },
} as const

export type CourseKey = keyof typeof productIdMappings.uat
export type Environment = keyof typeof productIdMappings

/**
 * Get the product ID for a given course and environment
 */
export const getProductId = (courseKey: CourseKey, environment: Environment): string => {
  return productIdMappings[environment][courseKey]
}

/**
 * Find course key by product ID (reverse lookup)
 */
export const getCourseKeyByProductId = (productId: string, environment: Environment): CourseKey | undefined => {
  const mappings = productIdMappings[environment]
  return (Object.keys(mappings) as CourseKey[]).find((key) => mappings[key] === productId)
}
